import { getDomain } from "../common/getDomain";

const useDomainCheck = () => {
  const domain = getDomain(true);

  const isFrontAssistDomain = domain === "cloud.frontassist.eu";

  const isCenterParcsDomain = domain === "centerparcs.castit.nl";

  return { isFrontAssistDomain, isCenterParcsDomain };
};

export { useDomainCheck };
